var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 10.024,
    viewBox: "0 0 20 10.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "link",
    d: "M1.921,12.095a3.013,3.013,0,0,0,.89,2.178,2.951,2.951,0,0,0,2.2.913H8.993v1.921H5.012a4.824,4.824,0,0,1-3.537-1.475A4.824,4.824,0,0,1,0,12.095,4.824,4.824,0,0,1,1.475,8.558,4.824,4.824,0,0,1,5.012,7.083H8.993V9H5.012a2.952,2.952,0,0,0-2.2.913A3.01,3.01,0,0,0,1.921,12.095ZM6,13.079V11.111h8.009v1.967Zm8.993-6a4.824,4.824,0,0,1,3.537,1.475A4.822,4.822,0,0,1,20,12.095a4.827,4.827,0,0,1-1.475,3.537,4.822,4.822,0,0,1-3.536,1.475H11.008V15.186h3.981a3.119,3.119,0,0,0,3.091-3.091A3.119,3.119,0,0,0,14.989,9H11.008V7.083Z",
    transform: "translate(0 -7.083)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.49b9d6079b50601e77bcd9fcc07f0975.svg";
export { ForwardRef as ReactComponent };